module.exports = __webpack_public_path__ + "static/media/no-result-found.19a9450d.png";